module.exports = __webpack_public_path__ + "static/media/icon-wallet.7a71b2d4.svg";